<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ modalName }}</div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="modal-body body-modal">
    <!-- Dynamic Properties Table starts here -->
    <form [formGroup]="propertiesForm">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th style="width: 30%">Property name</th>
            <th style="width: 30%">Value</th>
            <th style="width: 40%">New value</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of jsonData; let i = index">
            <td style="width: 30%">{{ item.propertyName }}</td>
            <td style="width: 30%">{{ item.defaultValue }}</td>
            <td style="width: 40%">
              <div class="form-group" *ngIf="!isDropdown(item.datatype)">
                <div class="services-form">
                  <input
                    type="text"
                    class="form-control personalInputFiled"
                    [formControlName]="getControlNameForItem(item, i)"
                  />
                  <div
                    *ngIf="isFieldInvalid(getControlNameForItem(item, i))"
                    class="text-danger validation-message"
                  >
                    {{ getErrorMessage(getControlNameForItem(item, i)) }}
                  </div>
                </div>
              </div>

              <!-- Dropdown for other datatypes -->

              <div
                *ngIf="isDropdown(item.datatype) && item.datatype !== datatype.MaterialDropdown"
                id="parent"
              >
                <ng-select
                  #dropdown
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  class="personalInputFiled fixed-height-select"
                  [items]="getDropdownOptions(item.datatype)"
                  [searchable]="false"
                  [searchFn]="commonInputSearch"
                  [formControlName]="getControlNameForItem(item, i)"
                  bindLabel="name"
                  placeholder="Select..."
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        type="text"
                        class="accordion-search form-control search-input"
                        id="inputValidation"
                        (input)="dropdown.filter($any($event.target).value)"
                        placeholder="Search..."
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                      {{ item?.name }}
                    </div>
                  </ng-template>
                </ng-select>
                <div
                  *ngIf="isFieldInvalid(getControlNameForItem(item, i))"
                  class="text-danger validation-message"
                >
                  {{ getErrorMessage(getControlNameForItem(item, i)) }}
                </div>
              </div>
              <div
                *ngIf="isDropdown(item.datatype) && item.datatype == datatype.MaterialDropdown"
                id="child"
              >
                <ng-select
                  #material
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  class="accordion-text addScroll fixed-height-select"
                  [items]="getDropdownOptions(item.datatype)"
                  [searchable]="false"
                  [searchFn]="commonInputSearchForDes"
                  groupBy="childItems"
                  [formControlName]="getControlNameForItem(item, i)"
                  bindLabel="description"
                  placeholder="Select..."
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        type="text"
                        class="accordion-search form-control search-input"
                        id="inputValidation"
                        (input)="material.filter($any($event.target).value)"
                        placeholder="Search..."
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                      {{ item?.name }}
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                      {{ item?.description }}
                    </div>
                  </ng-template>
                </ng-select>
                <div
                  *ngIf="isFieldInvalid(getControlNameForItem(item, i))"
                  class="text-danger validation-message"
                >
                  {{ getErrorMessage(getControlNameForItem(item, i)) }}
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>

  <div class="modal-footer text-margin">
    <button type="button" class="btn btn-light cancelBtn" (click)="onClose()">Cancel</button>
    <button
      type="button"
      class="modelBtn purpleBtnHoverEffect"
      [disabled]="propertiesForm.invalid"
      (click)="onSave()"
    >
      Save
    </button>
  </div>
</div>
